export const WHATSAPP_CONFIG = {
    numbers: [
        '5511938006666', // Telefone A (Adilson)
        '5511953148778', // Telefone B (Daniel)
        '5511985256688'  // Telefone C (Luiz)
    ],
    message: 'Oi, peguei o contato no site e gostaria de mais informações.'
};

declare global { // Extend Window interface
    interface Window { whatsAppNumber: string; }
}

export function getRandomWhatsAppNumber(): string {
    if (typeof window !== 'undefined' && window.whatsAppNumber) {
        return window.whatsAppNumber;
    }
    // Fallback if window.whatsAppNumber is not set (e.g. server-side rendering or dev without index.html setup)
    const randomIndex = Math.floor(Math.random() * WHATSAPP_CONFIG.numbers.length);
    return WHATSAPP_CONFIG.numbers[randomIndex];
}

export function getWhatsAppUrl(): string {
    const number = getRandomWhatsAppNumber();
    const encodedMessage = encodeURIComponent(WHATSAPP_CONFIG.message);
    return `https://wa.me/${number}?text=${encodedMessage}`;
}

export function getWhatsAppUrlLP2(): string {
    // LP2 uses a fixed number, which ignores the rotation.
    // If consistency is required even here, this function might need to change,
    // but for now, maintaining original behavior for LP2 as it wasn't explicitly asked to change its logic,
    // only that ZapBalloon matches the 'rotation' (which implies the main flow).
    const number = '5511985256688';
    const encodedMessage = encodeURIComponent(WHATSAPP_CONFIG.message);
    return `https://wa.me/${number}?text=${encodedMessage}`;
}
